class IndustrySlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this;
        this.initSlider();
    }

    initSlider() {
        new Swiper(this.slider, {
            slidesPerView: 1,
            grabCursor: true,
            spaceBetween: 15,
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
  
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                1220: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },

            },

        });
    }
}

customElements.define('industry-solution', IndustrySlider);

console.log("Industry Slider Loaded");
